import { DashboardLayout } from 'lib-dashboard-types';
import { SearchQueue } from 'lib-search-types';
import { createContext, useContext } from 'react';

export type QueueDashboardQueueContextValue = {
  /** The index of the queue in the list. */
  index: number;
  /**
   * The optional queue the metrics are associated with. If not provided, the
   * metric is a global or aggregate metric of all queues.
   */
  queue?: SearchQueue;
  /**
   * The optional list of queue IDs the metrics are associated with. Used for
   * aggregate metrics representing multiple queues.
   */
  allQueueIds?: readonly string[];

  /** Whether to show the skeleton UI, e.g. when loading. */
  isSkeleton?: boolean;
  /** The preferred dashboard layout. */
  layout?: DashboardLayout;
  /**
   * Whether the metric card is visually highlighted (purple accent). Defaults
   * to true for aggregate metrics (when `queue` is not set).
   */
  highlighted?: boolean;
};

export const QueueDashboardQueueContext =
  createContext<QueueDashboardQueueContextValue>(undefined!);

export const useQueueDashboardQueueContext =
  (): QueueDashboardQueueContextValue => {
    return useContext(QueueDashboardQueueContext);
  };
